import Button from "@/components/button/Button.tsx";
import {DatePickerShortcutListProps} from "@/components/datePicker/subComponents/DatePickerShortcutList/DatePickerShortcutList.types.ts";
import {DATEPICKER_STANDARD_DATE_RANGE_OPTIONS} from "@/components/datePicker/subComponents/DatePickerShortcutList/DatePickerShortcutList.utils.ts";
import classNames from "classnames";
import {useEffect, useState} from "react";
import {TZDate} from "react-day-picker";

export const DatePickerShortcutList = ({onChange, timezone, className, fixedRange}: DatePickerShortcutListProps) => {
  const referenceDate: Date = timezone ? TZDate.tz(timezone) : new Date();
  const [selectedOption, setSelectedOption] = useState(() =>
    DATEPICKER_STANDARD_DATE_RANGE_OPTIONS.find((o) => o.value === fixedRange)
  );

  useEffect(() => {
    setSelectedOption(DATEPICKER_STANDARD_DATE_RANGE_OPTIONS.find((o) => o.value === fixedRange));
  }, [fixedRange]);

  return (
    <div className={classNames(className, "d-flex flex-column gap-3")}>
      {DATEPICKER_STANDARD_DATE_RANGE_OPTIONS.map((option) => (
        <Button
          key={option.label}
          className={classNames("justify-content-start", {active: selectedOption?.label === option.label})}
          variant={"datePicker"}
          onClick={() => {
            const start = option.getStartDate(referenceDate);
            const end = option.getEndDate(referenceDate);
            setSelectedOption(option);
            onChange(start, end, option.value);
          }}
        >
          <div>{option.label}</div>
        </Button>
      ))}
    </div>
  );
};
